<template>
  <div id="occurrence-donut-chart">
    <apexchart :options="chartOptions" :series="series"></apexchart>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
  components: { apexchart: VueApexCharts },
  data: () => ({ }),
  props: ['occurrences', 'target', 'filename'],
  computed: {
    data() {
      if(!this.occurrences || this.occurrences.length == 0 || !this.target || this.target.length == 0) {
        return []
      }

      const reduced = this.occurrences.map(o => ({ 
        name: o[this.target.name],
        overdue: o.overdue
      })).reduce((acc, item) => {
        if (!acc[item.name]) {
            acc[item.name] = { onTime: 0, overdue: 0 };
        }
        if (item.overdue) {
            acc[item.name].overdue += 1;
        } else {
            acc[item.name].onTime += 1;
        }
        return acc;
      }, {})

      return reduced
    },
    series() {
      return [
        Object.keys(this.data).map(k => this.data[k].onTime).reduce((sum, x) => sum + x, 0),
        Object.keys(this.data).map(k => this.data[k].overdue).reduce((sum, x) => sum + x, 0)
      ]
    },
    chartOptions() {
      const self = this;
      return {
        colors:['#00909F', '#FF751B', '#4C999A', '#FF8E3C', '#7BA687', '#89FFDB'],
        chart: {
          type: 'donut',
          toolbar: {
            show: true,
            tools: {
              download: true
            },
            export: {
              csv: { filename: self.filename },
              png: { filename: self.filename },
              svg: { filename: self.filename },
            }
          },
        },
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
                total: {
                  showAlways: true,
                  show: true
                }
              }
            }
          }
        },
        labels: [this.$t('no-prazo'), this.$t('em-atraso')],
        stroke: {
          width: 0,
          colors: undefined
        },
        legend: {
          position: 'left'
        },
      }
    },
    label() {
      return this.$t('quantidade')
    },
  }
}
</script>